import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CheckBoxField from "../../../../Form/CheckBoxField/CheckBoxField";
import { indexOf } from 'lodash';
import highlightTerm from "./highlightTerm";
import cn from "../../../../../utils/cn";
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOptionChild = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    child,
    activeFilters,
    onChange,
    searchTerm,
    idPrefix
  } = _ref;
  const childLabel = searchTerm ? highlightTerm(child.label, searchTerm) : child.label;
  const isChecked = indexOf(activeFilters, child.value) >= 0;
  const childId = `${idPrefix}${child.value}`;
  const childOptionClass = cn(`${idPrefix}child`, {
    'px-6 py-2 min-h-10 place-content-center border-l-4 border-transparent': true,
    'bg-white hover:border-action-blue hover:bg-medium-fill-blue': !child.selectionDisabled,
    'bg-dark-border-grey cursor-default': child.selectionDisabled
  });
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: childOptionClass,
    children: /*#__PURE__*/_jsx(CheckBoxField, {
      id: childId,
      label: childLabel,
      value: isChecked,
      onChange: e => onChange(child, e.target.checked),
      disabled: child.selectionDisabled
    })
  });
});
FilterOptionChild.propTypes = {
  child: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    initial: PropTypes.bool,
    selectionDisabled: PropTypes.bool.isRequired
  }).isRequired,
  activeFilters: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  idPrefix: PropTypes.string.isRequired
};
export default FilterOptionChild;
//# sourceMappingURL=FilterOptionChild.js.map